import loadable from '@loadable/component';

export const GenplanLoadable = loadable(() => import('./Genplan'));
